<template>
  <div id="app">
    <b-navbar toggleable="md" type="dark" variant="dark">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/home">Akribes</b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/home">Home</b-nav-item>
          <b-nav-item to="/patient">Patienten-Übersicht</b-nav-item>
          <b-nav-item to="/exudats">Experimente</b-nav-item>
          <b-nav-item to="/patient-properties/medication">Medikamente</b-nav-item>
          <b-nav-item to="/patient-properties/comorbidity">Komorbiditäten</b-nav-item>
          <b-nav-item to="/trash-bin/patient">Papierkorb</b-nav-item>
          <b-nav-item href="#" @click.prevent="login" v-if="!activeUser">Anmelden</b-nav-item>
          <b-nav-item href="#" @click.prevent="logout" v-else>{{activeUser}} abmelden</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!-- routes will be rendered here -->
    <router-view />
  </div>
</template>

<script>
import api from './api'

export default {
  name: 'app',
  data () {
    return {
      activeUser: null
    }
  },
  async created () {
    await this.refreshActiveUser()
  },
  watch: {
    // everytime a route is changed refresh the activeUser
    '$route': 'refreshActiveUser'
  },
  methods: {
    login () {
      this.$router.replace('/')
    },
    async refreshActiveUser () {
      var userInfo = await api.getUser()
      this.activeUser = userInfo
    },
    async logout () {
      await api.logout()
      this.$router.push('/')
    }
  }
} // src="vue-multiselect/dist/vue-multiselect.min.css">
</script>
<style>
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }
  .list-enter {
    opacity: 0.5;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
  th {
    padding-left: 20px;
  }
  th:hover {
    color: rgb(29, 157, 167);
  }
  td {
    padding-left: 20px;
  }
  .form-control {
    cursor: pointer;
  }
  .form-control:hover{
    background-color: rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.5);
  }
  .barchart {
    width: 1000;
    height: 500px;
  }
  .map-chart {
    height: 450px;
  }
  .exit-cross {
    float: right;
    cursor: pointer;
  }
  .exit-cross:hover {
    background-color: rgba(153, 23, 23, 0.6);
  }
  .table-responsive {
    height: 500px;
  }
  .filter-group {
    float: left;
  }
.dropdown-control {
    height: 34px !important;
 }
 .table-striped tbody tr:nth-of-type(2n+1) {
    background-color: rgba(0, 0, 0, 0.05) !important;
 }
 .activeOption {
   color: #1DC7EA;
 }
  .nicole {
  border: 0px;
  font-style: italic;
  -webkit-text-fill-color: lightgrey;
  padding-left: 5px;
  background-color: transparent;
}
.nicole-text {
  border: 0px;
  padding-left: 5px;
  background-color: transparent;
}
.login-field {
  margin: 5px 5px 5px 0px;
}
.caption {
  text-align: center;
  font-size: 20px;
}
.overview-text {
  text-align: justify;
}
.card {
  margin: 5px;
}
.card label {
  font-size: 12px;
  margin-bottom: 5px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 400;
  color: #9A9A9A;
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue